module.exports = __webpack_public_path__ + "static/media/HCMM960.5a7b0ac8.jpg";